"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HexString = void 0;
const zod_1 = require("zod");
/**
 * A string with hex encoded value
 */
exports.HexString = zod_1.z.custom(val => typeof val === 'string' && /^0x(?:[0-9a-f])*$/i.test(val), 'Invalid hex string');
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGV4LXN0cmluZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9oZXgtc3RyaW5nLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDZCQUF1QjtBQUV2Qjs7R0FFRztBQUNVLFFBQUEsU0FBUyxHQUFHLE9BQUMsQ0FBQyxNQUFNLENBQy9CLEdBQUcsQ0FBQyxFQUFFLENBQUMsT0FBTyxHQUFHLEtBQUssUUFBUSxJQUFJLG9CQUFvQixDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsRUFDaEUsb0JBQW9CLENBQ3JCLENBQUEifQ==